<ng-previous-requests-form
  *ngIf="(store$ | async) as store"
  [statusAndRequest]="store.state.statusAndRequest"
  [selectedCustomerDetails]="store.selectedCustomerDetails"
  [isInternal]="store.internalRole"
  [filters]="store.state.filters"
  [keepFilters]="keepFilters"
  (submitPrevReq)="submitForm($event)"
  (saveFilters)="saveFilters($event)"
  (resetState)="resetState()"
></ng-previous-requests-form>
